import { render } from "./menubar.vue?vue&type=template&id=6e679e40"
import script from "./menubar.vue?vue&type=script&lang=js"
export * from "./menubar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__